var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.lineType === _vm.LINE_TYPE.RTC)?_c('rtc-stream',{ref:"rtcStream"}):_vm._e(),(_vm.lineType === _vm.LINE_TYPE.LEB)?_c('leb-stream',{ref:"lebStream"}):_vm._e(),(_vm.lineType === _vm.LINE_TYPE.CDN)?_c('cdn-stream',{ref:"cdnStream"}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }